import React, { useEffect, useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, RequiredRule, StringLengthRule,AsyncRule } from 'devextreme-react/form';
import { useSelector } from 'react-redux';

import { createStore } from '../../utils/proxy';
import { dataAccess, editorOptionsSelect, resources } from '../../data/app';
import {  Button } from 'devextreme-react';
import uri from '../../utils/uri';
import{ formatId, padIdInfo, padIdInfoData, valueHasAny, valueIsNullOrEmpty } from '../../utils/common';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { billDefault, receiptDefault } from '../../data/bill';
import useAuthorization from '../../hooks/useAuthorization';
import { paymentMethod } from '../../data/enums';

const Nuevo = (props) => {

    const { authorized } = useAuthorization([resources.closeBill, dataAccess.access]);

    const { data, onSave, close } = props;
    const { id, billId, open, client, balance } = data;

    const [saving, setSaving] = useState(false);
    const [reset, setReset] = useState(false);
    const [maxId, setMaxId] = useState(0);
    const [receipt, setReceipt] = useState({ ...receiptDefault });
    const [bill, setBill] = useState({ ...billDefault });

    const { appInfo } = useSelector(store => store);

    const refForm = useRef();

    const closeDialog = (load) => {

        close();
        if (load) {
            onSave();
        }
    }

    const onHiding = ({ load }) => {
        closeDialog(load);
    }

    useEffect(() => {

        http(`receivables/get/maxId`).asGet().then(({ idMax }) => {
            
            setMaxId(idMax);

            setReceipt({ ...receipt, id, billId, client, balance, amount: '', observation: '', reference: '', referencePayment: '', paymentMethodId : null, });

            http(`bill/${billId}/info`).asGet().then(resp => {

                if(resp)
                    setBill(resp);

                if (id > 0){

                    http(uri.receivables.getById(id)).asGet().then(_resp => {
                        
                        setReceipt({ ..._resp });
                        closeDialog(true);
                        
                    });
                }else{ 
                    if (open)
                        setReset(true);
                    else
                        setReset(false);
                }

            });

        });

       

    }, [id, billId]);

    const guardarRecibo = async (e) => {

        let resultValidate = refForm.current.instance.validate();

        let result = resultValidate;

        if(resultValidate.complete)
            result = await resultValidate.complete; 

        if (result.isValid) {

            setSaving(true);

            http(uri.receivables.insert).asPost(receipt).then(resp => {

                setSaving(false);
                notify(`Recibo ${resp.id} registrado correctamente`);
                closeDialog(true);

            }).catch(err => {

                setSaving(false);
                notify(err, 'error', 5000);

            });

        }

    }

    const isTranferOrCheckOrCard = value => [paymentMethod.cheque, paymentMethod.tarjeta, paymentMethod.deposito].includes(value);

    const validateAmount = e => {
        return new Promise(resolve => {
            resolve(
                 e.value > 0
            );
        });
    }

    const validateBank = e => {
        return new Promise(resolve => {
            resolve(
                (receipt.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(e.value))
                || (isTranferOrCheckOrCard(receipt.paymentMethodId) && valueHasAny(e.value)) 
            );
        });
    }

    const validateReferencePayment = e => {
        return new Promise(resolve => {
            resolve(
                (receipt.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(e.value))
                || (isTranferOrCheckOrCard(receipt.paymentMethodId) && valueHasAny(e.value))
            );
        });
    }

    const resetValues = () => {

        console.log(receipt);
        refForm.current.instance.resetValues();
        refForm.current.instance.updateData('date', receiptDefault.date);
        refForm.current.instance.updateData('maxId', padId(maxId));

    }

    useEffect(() => {
        if (reset) {
            
            resetValues();

        }
    } , [reset]);

    const padId = padIdInfo(appInfo);

    bill._numberBill = padId(bill.numberBill);

    return (
        <div>
            <Popup
                width={550}
                height={430}
                title={id > 0 ? `Ver recibo` : `Recibo de anticipo`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <Form formData={bill} readOnly={true}>
                    <GroupItem colCount={4}>
                        <SimpleItem dataField="_numberBill" colSpan={2}>
                            <Label text="No Factura#" />
                        </SimpleItem>
                        <SimpleItem dataField="balance" colSpan={2} editorType="dxNumberBox" editorOptions={{
                            format: '0#.00'
                        }}>
                            <Label text="Pendiente" />
                        </SimpleItem>
                        <SimpleItem dataField="name" colSpan={4}>
                            <Label text="Cliente" />
                        </SimpleItem>
                    </GroupItem>
                </Form>
                <br />
                <Form formData={receipt} ref={refForm}>
                    <GroupItem colCount={4}>
                        <SimpleItem dataField="date" colSpan={2} >
                            <Label text="Fecha" />
                            <RequiredRule message="Ingrese la fecha" />
                        </SimpleItem>   
                        <SimpleItem dataField="maxId" colSpan={2} editorOptions={{ readOnly:true }} >
                            <Label text="No Recibo" />
                            <RequiredRule message="Ingrese el No de recibo " />
                        </SimpleItem>
                        <SimpleItem dataField="paymentMethodId" editorType="dxSelectBox" colSpan={2}
                            editorOptions={{
                                dataSource: createStore({ name: 'billPaymentMethod' }),
                                ...editorOptionsSelect,
                                onValueChanged: e =>  {

                                    const isEfectivo = e.value == paymentMethod.efectivo;

                                    setReceipt({ ...receipt, 
                                        paymentMethodId: e.value,
                                        bankId : isEfectivo ? null : bill.bankId,
                                        referencePayment : isEfectivo ? '': bill.referencePayment
                                    })
                                }                              
                            }} >
                            <Label text="Forma pago" />
                            <RequiredRule message="Selecione la forma de pago" />
                        </SimpleItem>   
                        <SimpleItem dataField="amount" colSpan={2} editorType="dxNumberBox">
                            <Label text="Monto " />
                            <AsyncRule message="El monto es requerido" validationCallback={validateAmount}></AsyncRule>

                        </SimpleItem>                        
                        <SimpleItem dataField="bankId" editorType="dxSelectBox"  colSpan={2}
                            editorOptions={{
                                dataSource: createStore({ name: 'Bank' }),
                                ...editorOptionsSelect,
                                disabled: (receipt.paymentMethodId == paymentMethod.efectivo),
                            }} >
                            <Label text="Banco" />
                            <AsyncRule message="Seleccione el banco" validationCallback={validateBank}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="referencePayment" colSpan={2}
                            editorOptions={{
                                disabled:  receipt.paymentMethodId == paymentMethod.efectivo
                            }} >
                            <Label text="Referencia" />
                            <AsyncRule message="Ingrese la referencia" validationCallback={validateReferencePayment}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="observation" colSpan={4} editorType="dxTextArea">
                            <Label text="Observacion" />
                            <StringLengthRule max={150} message="Maximo 150 caracteres" />
                        </SimpleItem>
                    </GroupItem>
                </Form>
                <Button
                    className="mt-10"
                    text={saving ? 'Guardando...' : `Guardar recibo`}
                    type="success"
                    icon='save'
                    disabled={saving}
                    onClick={guardarRecibo}
                />
            </Popup>
        </div>
    );
}

export default Nuevo;
